
import Vue from 'vue'
import { Alert, Loading } from '@/components'
import Header from './components/Header.vue'
import ProductsInCart from './components/ProductsInCart.vue'
import OrderTotals from '../Checkout/components/OrderTotals.vue'
import PromoCodes from './components/PromoCodes.vue'
import StoreCredit from './components/StoreCredit.vue'
import ActionButtons from './components/ActionButtons.vue'
import QuickAdd from './components/QuickAdd.vue'
import PromoteSubscription from './components/PromoteSubscription.vue'

export default Vue.extend({
   name: 'CartPage',
   computed: {
      loaded() {
         return this.$store.state.modelDataLoaded
      },
      empty() {
         return this.$store.state.modelData.CartItems.length === 0
      },
   },
   methods: {},
   components: {
      Header,
      Loading,
      ActionButtons,
      ProductsInCart,
      StoreCredit,
      OrderTotals,
      Alert,
      PromoCodes,
      QuickAdd,
      PromoteSubscription,
   },
})
